import React, { useEffect, useRef, useState } from 'react';
import { useFingotiAuth } from '@fingoti/auth-js/react';
import { FingotiLoading, FingotiFullscreenStatus } from '@fingoti/components';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({

    root: {
        height: '75vh'
    }

}))

export const Logout = () => {

    const classes = useStyles();
    const { logout, isAuthenticated, isLoading } = useFingotiAuth();
    const [failed, setFailed] = useState(false);
    // True once this mount kicks off logout(). logout() clears the session
    // (isAuthenticated -> false) just before navigating to the auth server, so
    // without this we'd flash the success screen in that gap. We only want the
    // success screen when the server redirects us back on a fresh mount.
    const initiatedLogout = useRef(false);

    useEffect(() => {
        // Only initiate logout when there's a live session. After the auth
        // server completes logout it redirects back here (returnTo below); by
        // then we're signed out, so we must NOT call logout() again or we'd
        // loop straight back to the server.
        if (!isLoading && isAuthenticated) {
            initiatedLogout.current = true;
            logout({ returnTo: window.location.origin + '/logout' }).catch((err) => {
                console.error('Logout failed', err);
                setFailed(true);
            });
        }
    }, [logout, isAuthenticated, isLoading]);

    // Show the loader while hydrating, while a session is present, and through
    // the outbound redirect this mount started (until the browser navigates).
    if (!failed && (isLoading || isAuthenticated || initiatedLogout.current)) {
        return <FingotiLoading />;
    }

    // Signed out and the server has redirected back to /logout (success), or
    // logout() rejected before redirecting (failure).
    return (
        <Grid container spacing={2} justify="center" alignItems="center" className={classes.root}>
            {
                failed ?
                    <FingotiFullscreenStatus
                        tagline="Logout failed"
                    />
                    :
                    <FingotiFullscreenStatus
                        success
                        tagline="Logged out"
                        message="Logged out successfully"
                    />
            }
        </Grid>
    );
};
